import type { SharedEventingV3Data } from 'bundles/account-profile/components/recruiting-profile-viewer/eventing/types';
import { useUserExperienceContext } from 'bundles/unified-common/contexts/UserExperienceContext';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

import { useEnterpriseProperties } from './useEnterpriseProperties';

export type EnterprisePropertiesForEventing = SharedEventingV3Data['enterprise'];

/**
 * Enterprise properties for eventing. When orgScopedHome is on, uses UserExperienceContext (org slug only);
 * otherwise uses legacy useEnterpriseProperties (org + program slug).
 */
export function useEnterprisePropertiesForEventing(): EnterprisePropertiesForEventing | null {
  const legacyEnterpriseProperties = useEnterpriseProperties();
  const { userExperience } = useUserExperienceContext();
  const isOrgScopedHomeEnabled = useIsOrgScopedHome();

  let enterprisePropertiesToUse: EnterprisePropertiesForEventing | null = legacyEnterpriseProperties;
  if (
    isOrgScopedHomeEnabled &&
    userExperience?.__typename === 'UserExperienceContext_EnterpriseSelection' &&
    userExperience.organization?.slug
  ) {
    enterprisePropertiesToUse = {
      organizationSlug: userExperience.organization.slug,
      programSlug: undefined,
    };
  }
  return enterprisePropertiesToUse;
}
